import React, { useState, useEffect } from "react";
import AuthContext from "./AuthContext";
import { AuthState, EAuthStatus } from "../types/auth.type";
import { initialUser } from "../types/user.type";
import { getToken, removeToken } from "../helpers/auth";
import { message, Spin } from "antd";
import { getErrorMessage } from "../helpers/errorHandler";
import { getLoginData } from "../helpers/auth";
import { initialEmployee } from "../types/employee.type";

type Props = {
	children?: React.ReactNode;
};

const AuthProvider: React.FC<Props> = ({ children }) => {
	const [auth, setAuth] = useState<AuthState>({
		status: EAuthStatus.LOGGED_OUT,
		user: initialUser,
		employees: [initialEmployee],
		currentPosition: "",
		employeeId: "",
		officeId: "",
		roles: [],
	});
	const [isLoading, setIsLoading] = useState<boolean>(true);

	useEffect(() => {
		const token = getToken();
		if (!token) {
			setIsLoading(false);
			return;
		}

		getLoginData()
			.then((result) => {
				setAuth({
					status: EAuthStatus.LOGGED_IN,
					...result,
				});
			})
			.catch((err) => {
				message.error(getErrorMessage(err));
				console.error(err);
				removeToken();
			})
			.finally(() => setIsLoading(false));

		// eslint-disable-next-line
	}, []);

	return (
		<AuthContext.Provider value={{ auth, setAuth, isLoading, setIsLoading }}>
			{!isLoading ? (
				children
			) : (
				<Spin size="large">
					<div style={{ width: "100vw", height: "100vh" }} />
				</Spin>
			)}
		</AuthContext.Provider>
	);
};
export default AuthProvider;
